import axios from 'axios';

export class AvailabilityPreferencesResource {
  public static updatedPreferredDates(dates: Date[], leadId: number) {
    return axios.post(`/leads/${leadId}/availability_preferences`, { preferred_dates: dates });
  }
}
